export default __webpack_public_path__ + "static/media/Hats08.637208ad.png";